/**
 * Main application entry point.
 *
 * @author Stanislav Kalashnik <sk@infomir.eu>
 * @license GNU GENERAL PUBLIC LICENSE Version 3
 */

'use strict';

var app     = require('mag-app'),
    gettext = require('spa-gettext');

// main application events
app.once('load', function () {
    // load language first
    gettext.load({name: window.core.environment.language}, function ( error ) {
        if ( error ) {
            debug.info('language load error');
        }

        // set pages
        app.pages = {
            info: require('./pages/info'),
            more: require('./pages/more'),
            add: require('./pages/add'),
            main: require('./pages/main')
        };

        app.ready();
    });
});
